module.exports = __webpack_public_path__ + "img/title_txt_day4.bc3d14c5.png";